export { default } from './DeliveryModeBadge';
